import type { ReactNode } from "react"
import { cn } from "@/lib/utils"

export interface PlanSummaryRowProps {
  planName: string
  statusCaption?: ReactNode
  actionSlot?: ReactNode
  className?: string
}

export function PlanSummaryRow({
  planName,
  statusCaption,
  actionSlot,
  className,
}: PlanSummaryRowProps) {
  return (
    <div
      className={cn(
        "rounded-md border border-border bg-card p-5 flex items-start justify-between gap-4",
        className,
      )}
    >
      <div className="flex flex-col gap-0.5">
        <span className="text-section text-foreground">{planName}</span>
        {statusCaption && (
          <span className="text-caption text-muted-foreground">{statusCaption}</span>
        )}
      </div>
      {actionSlot && <div className="shrink-0">{actionSlot}</div>}
    </div>
  )
}
